const status = {
  INACTIVE: 0,
  ACTIVE: 1,
};

const texts = {
  [status.INACTIVE]: 'Inativo',
  [status.ACTIVE]: 'Ativo',
};

export default status;

export const getText = (s) => texts[s];